<template>
  <div style="padding-top: 25px">
    <div id="myCanvas1"></div>
  </div>
</template>
<script>
import { SleepWave } from "./js/sleepWave";
export default {
  data() {
    return {};
  },

  mounted() {
    const app = document.getElementById("myCanvas1");
    const options = {};
    const sleepWindow1 = new SleepWave(options);
    sleepWindow1.init(app);

    // 在需要绘制的时候setOptions
    sleepWindow1.setOption({
      types: ["1", "2", "3", "4","5"],
      data: [
        { label: "1", value: 12 },
        { label: "2", value: 12 },
        { label: "4", value: 12 },
        { label: "2", value: 10 },
        { label: "3", value: 8 },
        { label: "4", value: 6 },
        { label: "3", value: 20 },
        { label: "4", value: 12 },
        { label: "1", value: 11 },
        { label: "2", value: 12 },
        { label: "4", value: 10 },
        { label: "1", value: 17 },
        { label: "3", value: 12 },
        { label: "2", value: 20 },
        { label: "3", value: 8 },
        { label: "4", value: 16 },
        { label: "3", value: 21 },
        { label: "4", value: 11 },
        { label: "1", value: 15 },
        { label: "2", value: 20 },
        { label: "4", value: 15 },
        { label: "1", value: 10 },
        { label: "2", value: 17 },
        { label: "3", value: 12 },
        { label: "4", value: 20 },
        { label: "2", value: 19 },
        { label: "1", value: 20 },
        { label: "2", value: 30 },
        { label: "3", value: 20 },
        { label: "1", value: 10 },
        { label: "4", value: 10 },
      ],
    });
  },

  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/views/canvas/index.vue